// extracted by mini-css-extract-plugin
module.exports = {"transitionDuration":"300ms","container":"sidebar-paginated_container__Hh7uv","transitioning":"sidebar-paginated_transitioning__ZhduB"};